export enum GoalType {
  PERSONAL_DEVELOPMENTAL = 'PERSONAL_DEVELOPMENTAL',
  PERSONAL_OPERATIONAL = 'PERSONAL_OPERATIONAL',
  DEPARTMENT = 'DEPARTMENT',
  COMPANY = 'COMPANY',
  OFFICE_LOCATION = 'OFFICE_LOCATION',
  TEAM = 'TEAM',
}
